export default "__VITE_ASSET__DQakCqkR__"